<template>
  <b-row>
    <b-col class="mx-1 mt-2 mb-1" align-h="between">
      <b-card border-variant="dark" class="fixed-height-card">
        <template #header>
          <div class="d-flex align-items-center">
            <b-icon icon="info-circle" class="mr-2 text-dark" font-scale="1.5"></b-icon>
            <span class="fs-1 font-weight-bold">Details</span>
          </div>
        </template>
        <b-list-group flush>
          <b-list-group-item
            v-for="(item, index) in metadataItems"
            :key="index"
            class="d-flex justify-content-between align-items-center px-3 py-2"
          >
            <div class="d-flex align-items-center flex-shrink-0 key-width mr-3">
              <b-icon :icon="getIcon(item.key)" class="text-primary mr-2"></b-icon>
              <span class="font-weight-bold text-nowrap">{{ item.key }}:</span>
            </div>
            <div class="flex-grow-1 text-left">
              <span v-if="Array.isArray(item.value)">
                <ul class="list-unstyled mb-0">
                  <li v-for="(val, i) in item.value" :key="i">{{ val }}</li>
                </ul>
              </span>
              <span v-else>{{ item.value }}</span>
            </div>
          </b-list-group-item>
        </b-list-group>
      </b-card>
    </b-col>
  </b-row>
</template>

<script>
export default {
  name: 'GenericMetadata',
  props: {
    metadata: {
      type: Object,
      required: true,
    },
    alertType: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      xtendId: null,
      metadataHandlers: {
        sigmaAlerts: this.sigmaAlertsHandler,
        unauthorizedSsids: this.unauthorizedSsidsHandler,
        unauthorizedDnsServers: this.unauthorizedDnsHandler,
        unauthorizedDomains: this.unauthorizedDomainsHandler,
      },
    };
  },
  created() {
    if (this.$route && this.$route.params) {
      this.xtendId = this.$route.params.id;
    }
  },
  computed: {
    metadataItems() {
      const keys = Object.keys(this.metadata || {});
      if (keys.length === 0) {
        return [];
      }
      const key = keys[0];
      const handler = this.metadataHandlers[key] || this.defaultHandler;
      return handler(this.metadata[key]);
    },
  },
  methods: {
    sigmaAlertsHandler(data) {
      const items = [];
      Object.entries(data || {}).forEach(([id, alerts]) => {
        alerts.forEach((alert) => {
          items.push({ key: 'ID', value: id });
          items.push({ key: 'Name', value: alert.name || '' });
          items.push({ key: 'Author', value: alert.author || '' });
          items.push({ key: 'Category', value: alert.category || '' });
          items.push({ key: 'Description', value: alert.description || '' });
          items.push({ key: 'ATT&CK ID(s)', value: alert.tags ? alert.tags.join(', ') : '' });
          items.push({ key: 'Reference(s)', value: alert.references ? alert.references.join(', ') : '' });
          items.push(
            { key: 'False Positive(s)', value: alert.false_positives ? alert.false_positives.join(', ') : '' },
          );
        });
      });
      return items;
    },
    unauthorizedSsidsHandler(data) {
      if (!data || !data[this.xtendId]) {
        return [];
      }
      return [{ key: 'Accessed SSIDs', value: data[this.xtendId] }];
    },
    unauthorizedDnsHandler(data) {
      if (!data || !data[this.xtendId]) {
        return [];
      }
      return [{ key: 'Accessed DNS', value: data[this.xtendId] }];
    },
    unauthorizedDomainsHandler(data) {
      if (!data || !data[this.xtendId]) {
        return [];
      }
      return [{ key: 'Accessed Domains', value: data[this.xtendId] }];
    },
    defaultHandler(data) {
      return [{ key: 'Metadata', value: JSON.stringify(data, null, 2) }];
    },
    getIcon(key) {
      const iconMap = {
        Name: 'person-circle',
        ID: 'key',
        Author: 'pencil-square',
        Category: 'folder',
        Description: 'file-earmark-text',
        'Accessed SSIDs': 'wifi',
        'Accessed DNS': 'globe',
        'Accessed Domains': 'globe',
        'Reference(s)': 'link',
        'ATT&CK ID(s)': 'shield-lock',
        'False Positive(s)': 'exclamation-triangle',
      };
      return iconMap[key] || 'question-circle';
    },
  },
};
</script>

<style scoped>
.key-width {
  min-width: 200px;
}
</style>
